import { Button, HSpacer, IconButton, Search, VSpacer } from "@/components/DesignSystem";
import { ModalBottomSheet } from '@/components/shared/ModalBottomSheet/ModalBottomSheet';
import { ProductListContent } from '@/components/shared/SubwalletBalance/ProductListContent';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { ApiProduct } from '@api/interfaces';
import ArrowBack from '@mui/icons-material/ArrowBack';
import { Box, Divider } from '@mui/material';
import { Stack } from '@mui/system';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface PromotionProductsBottomSheetProps {
  brandColor?: string,
  emptyText?: string,
  onClose: () => void,
  products: ApiProduct[],
  variant: 'products' | 'redeemable',
}

export const PromotionProductsBottomSheet = ({
  brandColor,
  emptyText,
  onClose,
  products,
  variant,
}: PromotionProductsBottomSheetProps) => {
  const [search, setSearch] = useState('');
  const { isMobile } = useMediaQuery();
  const { t } = useTranslation();
  const brandColorBg = brandColor || 'primary.main';

  const filteredProducts = search
    ? products.filter((p) => p.name.toLowerCase().includes(search.toLowerCase()))
    : products;

  return (
    <ModalBottomSheet
      bottomSheetContainerSx={{ overflow: 'hidden' }}
      footerSpacerSize="1"
      hideBottomCloseButton
      hideTopCloseButton
      onClose={onClose}
      open
      showFooter={false}
      showTopButton={false}
      testID="redeemable-products-modal"
      title={(
        <>
          <Stack alignItems="center" direction="row" width="100%">
            {isMobile ? (
              <IconButton
                onClick={onClose}
                sx={{ color: brandColorBg }}
                testID="redeemable-modal-back-button"
              >
                <ArrowBack />
              </IconButton>
            ) : (
              <Button
                onClick={onClose}
                startIcon={<ArrowBack />}
                sx={{ px: '12px', color: brandColorBg }}
                testID="redeemable-modal-back-button"
                variant="text"
              >
                {t($ => $.common.actions.back)}
              </Button>
            )}
            {isMobile && (
              <>
                <HSpacer size="2" />
                <Search
                  fullWidth
                  onChangeText={setSearch}
                  placeholder={variant === 'redeemable'
                    ? t($ => $.common.search.searchRedeemableProducts)
                    : t($ => $.common.search.searchProducts)}
                  testID="redeemable-products-search"
                  value={search}
                />
                <HSpacer size="3" />
              </>
            )}
          </Stack>
          {isMobile && (
            <>
              <VSpacer size="6" />
              <Divider sx={{ width: '100%' }} />
            </>
          )}
        </>
      )}
    >
      <Box sx={{ height: '80vh', overflow: 'auto' }}>
        <ProductListContent
          emptyText={emptyText}
          isMobile={isMobile}
          products={filteredProducts}
          productsCount={products.length}
          search={search}
          setSearch={setSearch}
          variant={variant}
        />
      </Box>
    </ModalBottomSheet>
  );
};
